import React, { useEffect, useState } from 'react'
import Ribbon from '../../../core/common/ribbon/ribbon'
import TextField from '../../../core/common/textFields/TextField'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import SummaryTab from './SummaryTab'
import DetailsTab from './DetailsTab'
import { useFormik } from 'formik'
import { useCreateAccountMutation, useGetAccountByIdQuery, useGetActiveContactLookupQuery, useGetContactsByAccountIdQuery, useLazyGetAccountByIdQuery, useUpdateAccountMutation } from '../../../services/EndPointsApis'
import { toast } from 'react-toastify'
import * as Yup from "yup";

const AddAccounts = () => {
    const accountId = useParams();

    const navigate = useNavigate();
    const location = useLocation();
    const handleBack = () => {
        navigate('/accounts')
    }
    const isReadOnly = location.pathname.includes('acccountDetails');
    const isEditing = location.pathname.includes('EditAccounts');
    const [updateId, setUpdateId] = useState(0);

    const items = [
        {
            tooltipLabel: 'Back',
            icon: svgIcons.BackIcon,
            onClick: () => handleBack(),
            // disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
            // disableIcon: svgIcons.disableUpdateIcon
        },
        //   { tooltipLabel: "View details", icon: svgIcons.eyeIcon }
    ]

    // API's
    const [triggerAccount, { data: useAccountById }] = useLazyGetAccountByIdQuery();

    const [createAccount, { data, isError, error, isSuccess, isLoading }] = useCreateAccountMutation();
    const [updateAccount, { data: updateAccountData, isError: updateAccountIsError, error: updateAccountError, isSuccess: updateAccountIsSuccess, isLoading: updateAccountIsLoading }] = useUpdateAccountMutation();
    const { data: getContactsLookup, refetch: refetchContactsLookup } = useGetActiveContactLookupQuery('')

    const { data: getContacts, refetch: refetchAccountContacts, isLoading: accountContactsLoading } = useGetContactsByAccountIdQuery({
        Id: accountId?.id
    });

    useEffect(() => {
        if (useAccountById?.result && Object.keys(useAccountById?.result).length > 0) {
            setUpdateId(useAccountById?.result?.accountId);
            formik.setValues({ ...useAccountById?.result });
        } else {
            // resetForm();
        }
    }, [useAccountById, updateId]);

    const AccountId=useAccountById?.result?.accountId;
    const AccountName=useAccountById?.result?.accountName;


    useEffect(() => {

        if (isEditing || isReadOnly) {
            triggerAccount({ id: accountId?.id })
        }
    }, [accountId, triggerAccount, isEditing, isReadOnly])

    //formik

    const initialValues = {
        accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        accountName: '',
        accountNumber: '',
        originatingLead: '',
        phone: '',
        email: '',
        fax: '',
        documentCenter: '',
        primaryPDM: '',
        contactPreferences: '',
        business: '',
        contacts: '',
        industry: '',
        sicCode: '',
        tickerSymbol: '',
        ownership: '',
        lastCampaignDate: '2024-09-11T13:48:18.596Z',
        marketingMaterials: '',
        contactMethod: '',
        followEmail: '',
        bulkEmail: '',
        detailsPhone: '',
        detailsFax: '',
        currency: '',
        creditUnit: '',
        creditHold: '',
        paymentTerms: '',
        shippingMethod: '',
        freightTerms: '',
        isActive: true,
        createdDate: '2024-09-11T13:48:18.596Z',
        updatedDate: '2024-09-11T13:48:18.596Z',
        lst_PrimaryContact: {
            id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            value: ''
        },
    }

    const AccountSchema = Yup.object().shape({
        accountName: Yup.string()
            .required("Account Name is required"),
    })

    const formik = useFormik({
        initialValues,
        validationSchema: AccountSchema,
        onSubmit: (values) => {
            if (isEditing) {
                updateAccount({ ...values })
            } else {
                createAccount({ ...values });
            }
        },
    });
    const { resetForm } = formik;


    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            resetForm();
            navigate('/accounts')
        }
        if (updateAccountIsSuccess) {
            toast.success(updateAccountData?.message);
            resetForm();
            navigate('/accounts')
        }

    }, [isSuccess, updateAccountIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
        if (updateAccountIsError && updateAccountError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in updateAccountError && updateAccountError.data && typeof updateAccountError.data === 'object' && 'message' in updateAccountError.data) {
                errorMessage = (updateAccountError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error, updateAccountIsError, updateAccountError]);
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="row ">
                    <div className="col-md-12">
                        <Ribbon
                            items={items}
                            // buttonText="Save"
                            buttonText={isEditing
                                ? (updateAccountIsLoading ? 'Please wait...' : 'Update')
                                : (isReadOnly
                                    ? ''
                                    : (isLoading
                                        ? 'Please wait...'
                                        : 'Save'
                                    )
                                )}
                            // buttonText2='Share'
                            // Icon={svgIcons.shareIcon}
                            buttonClass="add-popup ribbon-btn "
                            onClickbtn={formik.handleSubmit}
                        />
                    </div>
                    <div>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="summary">
                            <Row>
                                <Col sm={12}>
                                    <div className='card'>
                                        <div className='card-body p-3 card-css'>
                                            <h4 className='color-red mb-3'>
                                                {isEditing ? "Edit Account" :isReadOnly?'View Account':'Add Account'} <span className='text-muted fs-12'></span>
                                            </h4>
                                            <Nav className=''>
                                                <Nav.Item>
                                                    <Nav.Link className="nav-tabs" eventKey="summary">Summary</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link className="nav-tabs" eventKey="details">Details</Nav.Link>
                                                </Nav.Item>
                                                {/* <Nav.Item>
                                                    <Nav.Link className="nav-tabs" eventKey="related">Related</Nav.Link>
                                                </Nav.Item> */}
                                            </Nav>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} style={{height:'650px',overflow:'auto'}}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="summary">
                                            <SummaryTab isReadOnly={isReadOnly} 
                                            formik={formik}
                                             useAccountById={useAccountById}
                                              getContacts={getContacts}
                                              getContactsLookup={getContactsLookup}
                                              isEditing={isEditing}
                                              refetchContactsLookup={refetchContactsLookup}
                                              AccountId={AccountId}
                                              AccountName={AccountName}
                                              />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="details">
                                            <DetailsTab isReadOnly={isReadOnly} formik={formik} />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="related">Second tab content</Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddAccounts